"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.homeTrailerContent = void 0;
const languageUtils_1 = require("../languageUtils");
// NOTE: Record<keys, values>
const homeTrailer = {
    en: {
        new: 'new',
        // trailerName: '1st Trailer',
        // trailerName: 'Story Trailer',
        trailerName: 'Launch Trailer',
        trailerLink: 'https://www.youtube.com/watch?v=u4DXz3UCOyA?autoplay=1',
    },
    ca: {
        new: 'new',
        // trailerName: '1st Trailer',
        // trailerName: 'Story Trailer',
        trailerName: 'Launch Trailer',
        trailerLink: 'https://www.youtube.com/watch?v=u4DXz3UCOyA?autoplay=1',
    },
    au: {
        new: 'new',
        // trailerName: '1st Trailer',
        // trailerName: 'Story Trailer',
        trailerName: 'Launch Trailer',
        trailerLink: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
    },
    nz: {
        new: 'new',
        // trailerName: '1st Trailer',
        // trailerName: 'Story Trailer',
        trailerName: 'Launch Trailer',
        trailerLink: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
    },
    uk: {
        new: 'new',
        // trailerName: '1st Trailer',
        // trailerName: 'Story Trailer',
        trailerName: 'Launch Trailer',
        trailerLink: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
    },
    fr: {
        new: 'Nouveau',
        // trailerName: '1ère bande-annonce',
        // trailerName: 'Bande-annonce Narrative',
        trailerName: 'Bande-annonce de lancement',
        trailerLink: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
    },
    de: {
        new: 'Neu',
        // trailerName: '1. Trailer ',
        // trailerName: 'Story-Trailer',
        trailerName: 'Launch Trailer',
        trailerLink: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
    },
    es: {
        new: 'Nuevo',
        // trailerName: 'Primer tráiler',
        // trailerName: 'Tráiler de la Historia',
        trailerName: 'Tráiler de lanzamiento',
        trailerLink: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
    },
    it: {
        new: 'Nuovo',
        // trailerName: '1° trailer',
        // trailerName: 'Trailer della Storia',
        trailerName: 'Trailer Lancio',
        trailerLink: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
    },
    pt: {
        new: 'Novo',
        // trailerName: '1º Trailer',
        // trailerName: 'Trailer da História',
        trailerName: 'Trailer de Lançamento',
        trailerLink: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
    },
    nl: {
        new: 'Nieuw',
        // trailerName: '1e trailer',
        // trailerName: 'Verhaaltrailer',
        trailerName: 'Lanceringstrailer',
        trailerLink: 'https://www.youtube.com/watch?v=CBe1U4BWTc4?autoplay=1',
    },
};
class homeTrailerContent {
    constructor() {
        this.new = document.querySelector('.newText');
        this.trailerName = document.querySelector('.trailerNameText');
        this.trailerLink = document.querySelector('.trailer__link');
        this.init();
    }
    init() {
        this.updateText();
    }
    updateText() {
        const language = (0, languageUtils_1.getLanguage)();
        const content = homeTrailer[language] || homeTrailer['en'];
        if (this.new)
            this.new.textContent = content.new.toUpperCase();
        if (this.trailerName)
            this.trailerName.textContent = content.trailerName.toLowerCase();
        if (this.trailerLink)
            this.trailerLink.setAttribute('href', content.trailerLink);
    }
}
exports.homeTrailerContent = homeTrailerContent;
